import {Map, Set} from 'immutable';
import {SET_APPS, ADD_NEW_APP, REMOVE_APP, SET_APP_ORGANIZATIONS} from './actions';

const apps = (state = Map({appIDs: Set(), appsMap: Map(), appOrganizationMap: Map()}), action) => {
  let newState = state;
  switch (action.type) {
    case SET_APPS:
      for (let i = 0; i < action.payload.apps.length; i += 1){
        newState = newState.setIn(['appsMap', action.payload.apps[i]._id], action.payload.apps[i]);
        newState = newState.setIn(['appIDs'], newState.get('appIDs').add(action.payload.apps[i]._id));
      }
      return newState;
    case ADD_NEW_APP:
      return newState
            .setIn(['appsMap', action.payload.app._id], action.payload.app)
            .set('appIDs', newState.get('appIDs').add(action.payload.app._id));
    case REMOVE_APP:
      newState = newState.deleteIn(['appsMap', action.payload.appId]);
      newState = newState.setIn(['appIDs'], newState.getIn(['appIDs'].delete(action.payload.appId)));
      return newState;
    case SET_APP_ORGANIZATIONS:
      return newState.setIn(['appOrganizationMap', action.payload.appId], action.payload.organizations);
    default:
      return newState
  }
}

export default apps;


// WEBPACK FOOTER //
// ./src/apps/reducer.js